import { useState, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { X, Chrome, Sparkles, ArrowRight } from 'lucide-react'
import Navbar from '../components/landing/Navbar'
import Hero from '../components/landing/Hero'
import Features from '../components/landing/Features'
import Testimonials from '../components/landing/Testimonials'
import Pricing from '../components/landing/Pricing'
import EmailCapture from '../components/landing/EmailCapture'
import FAQ from '../components/landing/FAQ'
import Footer from '../components/landing/Footer'
import ChatBot from '../components/landing/ChatBot'
import VoiceTour from '../components/landing/VoiceTour'

import EditorSandbox from '../components/landing/EditorSandbox'

function ExtensionWelcomeBanner({ onClose }) {
    const navigate = useNavigate()

    return (
        <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-cyan-500/90 via-blue-500/90 to-purple-500/90 backdrop-blur-sm border-b border-cyan-400/50">
            <div className="max-w-7xl mx-auto px-4 py-3">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                        <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
                            <Chrome className="w-5 h-5 text-white" />
                        </div>
                        <div className="min-w-0">
                            <h3 className="text-sm sm:text-base font-semibold text-white flex items-center gap-2">
                                <Sparkles className="w-4 h-4 text-yellow-300 flex-shrink-0" />
                                <span className="truncate">Thanks for installing InkSpot!</span>
                            </h3>
                            <p className="text-xs sm:text-sm text-white/90 truncate">
                                Sign up for Pro to unlock cliché detection everywhere.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                        <button
                            onClick={() => navigate('/signup')}
                            className="px-4 py-2 bg-white text-blue-600 font-medium text-sm rounded-lg hover:bg-white/90 transition-all flex items-center gap-1.5"
                        >
                            <span className="hidden sm:inline">Get Started</span>
                            <span className="sm:hidden">Sign Up</span>
                            <ArrowRight className="w-4 h-4" />
                        </button>
                        <button
                            onClick={onClose}
                            className="p-1.5 text-white/70 hover:text-white hover:bg-white/20 rounded-md transition-colors"
                            aria-label="Dismiss"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function LandingPage() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [showExtensionBanner, setShowExtensionBanner] = useState(false)

    useEffect(() => {
        // Check if user came from extension install
        if (searchParams.get('source') === 'extension') {
            setShowExtensionBanner(true)
            // Clean up the URL
            searchParams.delete('source')
            setSearchParams(searchParams, { replace: true })
        }
    }, [searchParams, setSearchParams])

    const handleCloseBanner = () => {
        setShowExtensionBanner(false)
    }

    return (
        <div className="min-h-screen bg-slate-950">
            {showExtensionBanner && <ExtensionWelcomeBanner onClose={handleCloseBanner} />}
            {/* Add spacer div when extension banner is showing */}
            {showExtensionBanner && <div className="h-16" />}
            <Navbar />
            <main>
                <Hero />
                <div id="sandbox" className="px-4 relative z-20 -mt-20 sm:-mt-32">
                    <EditorSandbox />
                </div>
                <Features />
                <Testimonials />
                <Pricing />
                <EmailCapture />
                <FAQ />
            </main>
            <Footer />
            <ChatBot />
            <VoiceTour />
        </div>
    )
}
